// import { message, Space } from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VideoRecorder from "react-video-recorder";
import { RecordRTCPromisesHandler } from "recordrtc";
import Videojs from "../../components/Videojs";
import LoaderComp from "../../LoaderComp";
import {
  addError,
  getCallId,
  getToken,
  getUserData,
} from "../../Redux/UserSlice";
import {
  backendApi,
  callPlayBot,
  fetchCustomApiWithToken,
  FinishApi,
  LiveCallApi,
  RecordApi,
  SubmitActivity,
} from "../../services/service";

const VideoPage = ({ languageContent, setPage }) => {
  const [openRecording, setOpenRecording] = useState(false);
  const [showRecordButton, setShowRecordButton] = useState(false);
  const [data, setData] = useState({});
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [error, setError] = useState("");
  const user = useSelector(getUserData);
  const token = useSelector(getToken);
  const call_id = useSelector(getCallId);
  const [showStartRecording, setShowStartRecording] = useState(false);
  const vidref = useRef();
  const timerRef = useRef();
  const dispatch = useDispatch();
  const [tries, setTries] = useState(0)

  const template_video_upload = async () => {
    await callPlayBot(call_id, "video_upload")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          setShowRecordButton(true);
          clearTimeout(timerRef.current);
        }
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };
  useEffect(() => {
    submitApi("video_upload_page", "open");
    template_video_upload();
    navigator.mediaDevices.getUserMedia({audio:true,video:true})
      .then((c) => console.log(c))
      .catch((err) => {
        backendApi(call_id, "video_permission", "denied")
        .then((res) => console.log())
        .catch((e) => console.log(e));
      })
    timerRef.current = setTimeout(async () => {
      await RecordApi(call_id)
        .then((res) => {
          console.log(res.data);
          if (res.data) {
            setShowRecordButton(true);
          }
        })
        .catch((e) => {
          console.log(e.message);
        });
    }, 25000);
    return () => clearTimeout(timerRef.current);
  }, []);

  const handleRecord = async () => {
    setError('');
    setShowStartRecording(true);
    setShowRecordButton(false);
    await backendApi(call_id, "video_record", "start")
      .then((res) => {
        if (res.data) {
          setOpenRecording(true);
        }
      })
      .catch((e) => {
        console.log(e.message);
        setPage("sorryPage");
      });
  };

  function getVideoData(blob) {
    //add promise and return
    return new Promise((resolve) => {
      if (blob) {
        blob.arrayBuffer().then((buffer) => {
          let req = {
            file: _arrayBufferToBase64(buffer),
            videoId: "videos/" + moment(new Date()).format("YYYY/MM/DD"),
            filename:
              "e1485218-e943-44ae-af17-2140f3e83672" +
              "_" +
              "EA10630114421" +
              "_" +
              moment(new Date()).format("YYYYMMDDHHmmss") +
              ".",
            //missing blobname
            contentType: blob.type,
          };
          console.log("fileName");
          console.log(req.filename);
          console.log("file");
          console.log(req.file);
          resolve(req);
        });
      }
    });
  }
  const _arrayBufferToBase64 = (buffer) => {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    console.log("byte-lebvgds", len);
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    console.log("binary", binary.length);
    // console.log("base64");
    // console.log("base64");
    // console.log(window.btoa(binary));
    return window.btoa(binary);
  };

  const handleCapture = async (videoBlob) => {
    
    await backendApi(call_id, "video_record", "stop").then((res) =>
      console.log(res.data)
    );
    let filedata = null;
    
    await videoBlob.arrayBuffer().then((buffer) => {
      filedata = _arrayBufferToBase64(buffer);
      setShowSubmitButton(true);
    });
    
    let type = videoBlob.type.split("/")[1].split(";")[0];
    console.log(filedata.le);
    setData({
      contentType: videoBlob.type,
      file: filedata,
      filename: `${user.application_number}_${moment(new Date()).format(
        "DDMMYYYY_HHmmss"
      )}_${call_id}.${type}`,
      videoId: "videos/" + moment(new Date()).format("YYYY/MM/DD"),
    });
  };
  const [disableSubmit, setDisableSubmit] = useState(false);
  const handleSubmit = async () => {
    if(tries >= 2){
      // setShowRecordButton(true)
      setShowSubmitButton(false)
      setError(languageContent.video_proof_page.record_again)
      setTries(0)
    }else{
      setDisableSubmit(true);
      setError(null);
      let key = "";
      await fetchCustomApiWithToken(
        call_id,
        "POST",
        `upload/${call_id}`,
        data,
        token
      )
        .then((res) => {
          if (res.data.response === "PASSED") {
            key = res.data.key;
            console.log(key);
            backendApi(call_id, "videoRecord_response", "success")
              .then((res) => {
                console.log(res.data);
              })
              .catch((e) => {
                console.log("videoRecord");
                // setError(languageContent.video_proof_page.recordFailure);
                // message.error({
                //   style: { fontSize: "1.25rem", color: "red" },
                //   content: languageContent.video_proof_page.recordFailure,
                // });
              });
            if (key) {
              SubmitActivity(call_id, "verification_video", key)
                .then((res) => {
                  console.log("submit", res.data);
                  if (res.data.status === "SUCCESS") {
                    FinishApi(call_id)
                      .then((res) => {
                        setPage("thankYouComplete");
                      })
                      .catch((e) => {
                        console.log("finish", e.message);
                        setError(languageContent.video_proof_page.recordFailure);
                      });
                  }
                })
                .catch((e) => {
                  console.log("submitActivity", e.message);
                  setError(languageContent.video_proof_page.recordFailure);
                });
            }
          } else {
            setTries(tries+1)
            setError(languageContent.video_proof_page.recordFailure);
          }
        })
        .catch((e) => {
          setTries(tries+1)
          setError(languageContent.video_proof_page.recordFailure);
        })
        .finally(() => {
          // setPage("thankYouComplete");
          setDisableSubmit(false);
        });
    }
    
  };
  const handleStop = () => {
    vidref.current.handleStop();
  };
  // Videojs
  const [data1, setData1] = useState(null);
  const [showStopButton, setShowStopButton] = useState(false);
  const [showStream, setShowStream] = useState(false);
  const [showRecordedStream, setShowRecordedStream] = useState(false);
  const [stream, setStream] = useState(null);
  const [recorder, setRecorder] = useState(null);
  let vref = useRef();
  let [video_local, setVi] = useState("");
  const handleStart = async () => {
    setShowStream(true);
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: {
        echoCancellation: true,
      },
    });
    if (stream) {
      vref.current.srcObject = stream;
    }
    const rec = new RecordRTCPromisesHandler(stream, {
      type: "video",
      mimeType: "video/webm",
    });
    await rec.startRecording();

    setRecorder(rec);
    setStream(stream);
    // setVideoUrlBlob(null)
    // preview.srcObject = stream;
  };
  async function onStop() {
    setShowStopButton(false);
    setShowStream(false);
    setShowRecordedStream(true);
    // stream.getTracks().forEach((track) => track.stop());
    if (recorder) {
      await recorder.stopRecording();
      const d = await recorder.getBlob();
      setData1(d);
      setRecorder(null);
      setStream(null);
      setShowStopButton(false);
      setShowSubmitButton(true);
    }
  }
  const renderHdfcContent = (user) => {
    if (user.language.toLowerCase() === "hin" ||
      user.language.toLowerCase() === "hindi") {
        return <>
        <p style={{ fontWeight: 'bold' }}>
            मैं {user.policy_owner_name}, {user.insured_name} के नाम से जीवन बीमा पॉलिसी के लिए आवेदन कर रहा हूं। मुझे पॉलिसी के लाभों की जानकारी है और बताए गए विवरणों से सहमत हूं।
          </p>
        </>
     
    }
    
    else {
          return <p style={{ fontWeight: 'bold' }}>
            I {user.policy_owner_name} am applying for a Life Insurance Policy in the name of {user.insured_name}. I am aware of the policy benefits and agree to the details voiced out. 
          </p>
 
    }
  }
  const renderNormalContent = (user) => {
    if (user.language.toLowerCase() === "hin" ||
      user.language.toLowerCase() === "hindi") {
      switch (user.product.toLowerCase()) {
        case 'ulip':
          return <p style={{ fontWeight: 'bold' }}>
            मैं {user.policy_owner_name}, एतद्द्वारा पुष्टि करता हूं कि मैने यूनिट लिंक्ड प्लान {user.plan_name} के विवरणों को समझ लिया है और मुझे समझाए गए नियमों व शर्तों से सहमत हूं. मैं {user.payment_frequency} आधार पर {user.payment_term} वर्षों के लिए रु. {user.premium_amount} अदा करने के लिए सहमत हूं.  मैं समझाए गए पॉलिसी लाभों से अवगत हूं. मैं एतद्द्वारा अपने आवेदन की प्रक्रिया के लिए सहमत हूं. मेरा मोबाइल नंबर है {user.msisdn}
          </p>
        case 'non par':
          return <p style={{ fontWeight: 'bold' }}>
            मैं {user.policy_owner_name}, एतद्द्वारा पुष्टि करता हूं कि मैने {user.plan_name} के विवरणों को समझ लिया है और मुझे समझाए गए नियमों व शर्तों से सहमत हूं. मैं {user.payment_frequency} आधार पर {user.payment_term} वर्षों के लिए लागू करों के साथ रु. {user.premium_amount} अदा करने के लिए सहमत हूं. मैं समझाए गए पॉलिसी लाभों से अवगत हूं. मैं एतद्द्वारा अपने आवेदन की प्रक्रिया के लिए सहमत हूं. मेरा मोबाइल नंबर है {user.msisdn}
          </p>
        case "term":
          return <p style={{ fontWeight: "bold" }}>
          {languageContent.video_proof_page.detail_2_a}
          {user.policy_owner_name}
          {languageContent.video_proof_page.detail_2_b}&nbsp;
          {user.plan_name}
          {languageContent.video_proof_page.detail_3}
          {user.msisdn}
        </p>
        default:
          return <p style={{ fontWeight: 'bold' }}>
            मैं {user.policy_owner_name}, एतद्द्वारा पुष्टि करता हूं कि मैने {user.plan_name} के विवरणों को समझ लिया है और मुझे समझाए गए नियमों व शर्तों से सहमत हूं. मैं {user.payment_frequency} आधार पर {user.payment_term} वर्षों के लिए लागू करों के साथ रु. {user.premium_amount} अदा करने के लिए सहमत हूं. मैं समझता हूं कि बोनसों की गारंटी नहीं है और मैं समझाए गए पॉलिसी लाभों से अवगत हूं. मैं एतद्द्वारा अपने आवेदन की प्रक्रिया के लिए सहमत हूं. मेरा मोबाइल नंबर है {user.msisdn}
          </p>
      }
    } else {
      switch (user.product.toLowerCase()) {
        case 'ulip':
          return <p style={{ fontWeight: 'bold' }}>
            I {user.policy_owner_name} hereby confirm that I have understood the details of the Unit Linked Plan {user.plan_name} and agree to the terms and conditions explained to me. I agree to pay premium of INR {user.premium_amount} for {user.payment_term} years on {user.payment_frequency} basis.  I am aware of the  policy benefits explained to me. I hereby agree to process my application. My Mobile number is {user.msisdn}
          </p>
        case 'non par':
          return <p style={{ fontWeight: 'bold' }}>
            
            I {user.policy_owner_name} hereby confirm that I have understood the details of the {user.plan_name} and agree to the terms and conditions explained to me. I agree to pay premium of INR {user.premium_amount} along with applicable taxes for {user.payment_term} years on {user.payment_frequency} basis.  I am aware of the  policy benefits explained to me. I hereby agree to process my application. My Mobile number is {user.msisdn}
          
          </p>
        case 'term':
          return <p style={{ fontWeight: "bold" }}>
          {languageContent.video_proof_page.detail_2_a}
          {user.policy_owner_name}
          {languageContent.video_proof_page.detail_2_b}&nbsp;
          {user.plan_name}
          {languageContent.video_proof_page.detail_3}
          {user.msisdn}
        </p>
        default:
          return <p style={{ fontWeight: 'bold' }}>
            I {user.policy_owner_name} hereby confirm that I have understood the details of the {user.plan_name} and agree to the terms and conditions explained to me. I agree to pay premium of INR {user.premium_amount} along with applicable taxes for {user.payment_term} years on {user.payment_frequency} basis. I understand that bonuses are not guaranteed and I am aware of the  policy benefits explained to me. I hereby agree to process my application. My Mobile number is {user.msisdn}
          </p>
      }
    }
  }
  return (
    <>
      <div className="heading">
        <p>{languageContent.video_proof_page.video_title}</p>
      </div>

      {openRecording ? (
        // <div>
        //   {showStream && <video ref={vref} muted autoPlay width="100%" />}
        //   {!!data1 && showRecordedStream && (
        //     <video
        //       src={window.URL.createObjectURL(data1)}
        //       id="preview2"
        //       autoPlay
        //       controls
        //       width="100%"
        //     />
        //   )}
        // </div>
        <VideoRecorder
          // mimeType="video/webm"
          // chunkSize={250}
          // dataAvailableTimeout={500}
  // useVideoInput={true}
          onStartRecording={() => {
            setShowSubmitButton(false);
            setShowStopButton(true);
            setError(null)
          }}
          ref={vidref}
          isFlipped={false}
          isOnInitially={true}
          onRecordingComplete={(videoBlob) => {
            setShowStopButton(false);
            // Do something with the video...
            console.log(videoBlob);
            handleCapture(videoBlob);
          }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "300px",
            background: "black",
            textAlign: "center",
          }}
        ></div>
      )}
      <p>{languageContent.video_proof_page.detail_1}</p>
      {
        user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" ?
          renderHdfcContent(user) : 
          renderNormalContent(user)
          
      }
      <div
        style={{
          // margin: "0 auto",
          display: showSubmitButton && "flex",
          justifyContent: "space-around",
          flexDirection: error && (error.length) > 0 && "column",
          backgroundColor: 'white',
          position: 'sticky',
          bottom: 0,
          padding: '1rem' 
          
        }}
      >
        {showRecordButton && (
          <button
            onClick={handleRecord}
            className="myButton"
            style={{ marginRight: "0.5rem" }}
          >
            {/* ? languageContent.buttons.retake */}
            {languageContent.buttons.initiate_recorder}
          </button>
        )}
        {showStopButton && (
          <button onClick={handleStop} className="myButton">
            {languageContent.buttons.stop}
          </button>
        )}
        {error && (error.length > 0) && (
        <p style={{color: "red",fontWeight: 400}}>
          {error}
          </p>
        )}
        {showSubmitButton && (
          <button
            onClick={handleSubmit}
            className="myButton"
            style={{}}
            disabled={disableSubmit}
          >
            {languageContent.buttons.submit}
          </button>
        )}
      </div>
      {/* {showStartRecording && (
        <button
          onClick={async () => {
            await vidref.current.startRecording();
            setShowStopButton(true);
          }}
        >
          starteee
        </button>
      )} */}
      {disableSubmit && <LoaderComp />}
    </>
  );
};

export default VideoPage;
